/* eslint-disable camelcase */ /* TODO: should the API be camelCase? */
import React from 'react'

import { track } from 'lib/analytics'
// eslint-disable-next-line import/no-extraneous-dependencies
import { BannerStrip } from 'baby-design'

import { getPlacementScreen } from 'lib/placements/getPlacementScreen'
import { registryProperties } from 'src/lib/tracking/shared/bundles/registryProperties'
import useOnCurrentUserLoaded from 'shared/hooks/useOnCurrentUserLoaded/useOnCurrentUserLoaded'
import { PlacementAd, filteredAds } from 'lib/placements/filteredAds'

interface AdProps {
  ad: PlacementAd
  unitId: string
}

export interface PlacementsGlobalBannerProps {
  unitId: string
  initialAds?: PlacementAd[]
  initialPath: string
  initialHost: string
  showBanner?: boolean
}

const Ad: React.FC<AdProps> = ({ unitId, ad }) => {
  let trackingContext = {
    eventLocation: track.EventLocation.WEB_TOP_NAV,
    adId: ad.adId,
    adTitle: ad.content.title,
    adUnitId: unitId,
    adCtaText: ad.content.ctaText || '',
    eventUrl: '',
  }
  useOnCurrentUserLoaded((currentUser) => {
    trackingContext = {
      ...trackingContext,
      ...registryProperties(currentUser),
      eventUrl: window?.location?.href,
    }
    track.targetedPlacementViewed(trackingContext)
  })

  const handleCtaClick = () => {
    if (ad.tracking?.ctaClickedUrl) {
      fetch(ad.tracking.ctaClickedUrl, { method: 'POST' })
    }
    track.targetedPlacementClicked(trackingContext)
  }

  const { adId, content } = ad
  return (
    <span data-testid={`adContent-${adId}`} key={`adContent-${adId}`}>
      {content.title}
      {content.ctaUrl && (
        <>
          {' '}
          <a href={content.ctaUrl} onClick={handleCtaClick}>
            {content.ctaText}
          </a>
        </>
      )}
    </span>
  )
}

/*
  **LIMITATION**
  The current implementation does not support refiltering on client side navigation.
  This is a design limitation since we do not want to have a page shift.
  For our near term usecase (black friday etc.), we are okay with this limitation as we do
  not have client side navigation across different domains of the website (eg: shop, registry, guides.)
  We do have client side navigation within the same domain (eg: shop category, shop brand, shop pdp)
  And for now we will want to make sure all those pages can show a banner.
*/

const PlacementsGlobalBanner: React.FC<PlacementsGlobalBannerProps> = ({
  unitId,
  initialAds,
  initialPath,
  initialHost,
  showBanner,
}) => {
  let pathname = initialPath
  let host = initialHost
  if (typeof window !== 'undefined') {
    pathname = window.location.pathname
    // eslint-disable-next-line prefer-destructuring
    host = window.location.host
  }

  const currentScreen = getPlacementScreen(pathname, host)
  const ads = filteredAds(initialAds, currentScreen)

  if (!showBanner || !ads || ads.length === 0) {
    return null
  }

  const adIndex = 0 // TODO: multiple rotating ads

  // TODO: dismissable banner
  return (
    <BannerStrip data-testid={`globalBanner-${unitId}`}>
      <Ad ad={ads[adIndex]} unitId={unitId} />
    </BannerStrip>
  )
}

export default PlacementsGlobalBanner
